import type { StudyQuantifierDB } from '../db';
import { migrateToV1 } from './v1';

export interface Migration {
  version: number;
  run: (db: StudyQuantifierDB) => Promise<void>;
}

const migrations: Migration[] = [
  { version: 1, run: migrateToV1 }
];

export async function runMigrations(db: StudyQuantifierDB): Promise<void> {
  for (const migration of migrations) {
    if (db.verno >= migration.version) continue;
    await migration.run(db);
  }
}